export var FinanceConsoleSubject;
(function (FinanceConsoleSubject) {
    FinanceConsoleSubject["FormContainer"] = "form-container";
    FinanceConsoleSubject["ActualPlansTable"] = "actual-plans-table";
    FinanceConsoleSubject["ProductPurchasesTable"] = "product-purchases-table";
    FinanceConsoleSubject["OnDemandPlansTable"] = "on-demand-plans-table";
    FinanceConsoleSubject["UpdateSuccess"] = "update-success";
    FinanceConsoleSubject["UpdateFailed"] = "update-failed";
    FinanceConsoleSubject["TransferBudgetSuccess"] = "transfer-budget-success";
    FinanceConsoleSubject["TransferBudgetFailed"] = "transfer-budget-failed";
    FinanceConsoleSubject["TransferBudgetButton"] = "transfer-budget-button";
    FinanceConsoleSubject["PriceChangesTable"] = "price-changes-table";
    FinanceConsoleSubject["AddPriceChangeButton"] = "add-price-change-button";
    FinanceConsoleSubject["AddPriceChangeModal"] = "add-price-change-modal";
    FinanceConsoleSubject["DeletePriceChangeButton"] = "delete-price-change-button";
    FinanceConsoleSubject["DeletePriceChangeModal"] = "delete-price-change-modal";
    FinanceConsoleSubject["PriceChangeSuccess"] = "price-change-success";
    FinanceConsoleSubject["PriceChangeFailed"] = "price-change-failed";
})(FinanceConsoleSubject || (FinanceConsoleSubject = {}));
export var ConsumptionPurchaseStatus;
(function (ConsumptionPurchaseStatus) {
    ConsumptionPurchaseStatus["PENDING"] = "PENDING";
    ConsumptionPurchaseStatus["DONE"] = "DONE";
})(ConsumptionPurchaseStatus || (ConsumptionPurchaseStatus = {}));
export var BillingType;
(function (BillingType) {
    BillingType["SUBSCRIPTION"] = "SUBSCRIPTION";
    BillingType["CONSUMPTION"] = "CONSUMPTION";
})(BillingType || (BillingType = {}));
export var CancelStatus;
(function (CancelStatus) {
    CancelStatus["DONE"] = "DONE";
    CancelStatus["CUSTOMER_CANCELED_PENDING"] = "CUSTOMER_CANCELED_PENDING";
})(CancelStatus || (CancelStatus = {}));
export var ProductUnit;
(function (ProductUnit) {
    ProductUnit["UTM"] = "UTM";
    ProductUnit["GB"] = "GB";
})(ProductUnit || (ProductUnit = {}));
//# sourceMappingURL=finance-console.js.map